export default "__VITE_ASSET__BDUbu2AY__"